export const fetchSiteVersion = () => {
    const VERSION_URL = process.env.REACT_APP_SITE_VERSION_JSON_URL;
    const cachedVersion = localStorage.getItem("site_version");
    const cachedTimestamp = localStorage.getItem("version_timestamp");

    const oneHourInMillis = 60 * 60 * 1000; // 1 hour
    const currentTime = Date.now();

    if (
        cachedVersion &&
        cachedTimestamp &&
        currentTime - cachedTimestamp < oneHourInMillis
    ) {
        return;
    }

    fetch(VERSION_URL)
        .then((res) => {
            if (!res.ok) {
                throw new Error("Failed to fetch version");
            }
            return res.json();
        })
        .then((data) => {
            const version = data.version;
            localStorage.setItem("site_version", version);
            localStorage.setItem("version_timestamp", currentTime);
        })
        .catch((err) => {
            console.error("Error fetching version:", err);
        });
};
